import {
  RunAnalysisRequestDto,
  RunAnalysisResponseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useMutation } from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_RUN_ANALYSIS = "RUN_ANALYSIS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const runAnalysis = async (
  dto: RunAnalysisRequestDto,
): Promise<RunAnalysisResponseDto> => {
  const token = localStorage.getItem("access_token") || "";
  const response = await paygapApi.paygapControllerRunAnalysis(
    `Bearer ${token}`,
    dto,
  );

  return response.data;
};

export const useRunAnalysis = (
  user: UserProfileDto | null,
): {
  runAnalysis: (dto: RunAnalysisRequestDto) => Promise<RunAnalysisResponseDto>;
  runAnalysisEnabled: boolean;
  isPendingRunAnalysis: boolean;
  isSuccessRunAnalysis: boolean;
  runAnalysisError: Error | null;
  resetRunAnalysis: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const mutation = useMutation<
    RunAnalysisResponseDto,
    Error,
    RunAnalysisRequestDto
  >({
    mutationKey: [DOMAIN_PAYGAP, ACTION_RUN_ANALYSIS],
    mutationFn: enabled
      ? runAnalysis
      : async (): Promise<RunAnalysisResponseDto> => {
          throw new Error(
            "Insufficient permissions to run analysis. Required roles: Owner or Manager.",
          );
        },
  });

  return {
    runAnalysis: (dto: RunAnalysisRequestDto) => mutation.mutateAsync(dto),
    runAnalysisEnabled: enabled,
    isPendingRunAnalysis: mutation.isPending,
    isSuccessRunAnalysis: mutation.isSuccess,
    runAnalysisError: mutation.error,
    resetRunAnalysis: mutation.reset,
  };
};
